module.exports = noop

// no operation
// null -> null
function noop() {}

// call noop to satisfy test cov suites
noop()
